<div class="modal inmodal fade in create-modal" [ngClass]="{'show': showModal}">
    <form #form="ngForm" (ngSubmit)="onSubmit(form)" submittable autocomplete="off">
        <div class="modal-dialog" style="width: 650px;">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="row">
                        <h4 class="modal-title col-sm-8">Create Vendor</h4>
                        <div class="input-group-btn pull-right">
                            <button tabindex="-1" class="btn btn-primary submit"
                                    type="submit" [disabled]="disabledSubmit">Save</button>
                            <button data-toggle="dropdown" class="btn btn-primary dropdown-toggle" type="button"
                                    aria-expanded="false"><span class="caret"></span></button>
                            <ul class="dropdown-menu pull-right">
                                <li><a (click)="closeModal()">Cancel</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="modal-body">
                    <!--** Vendor ** -->
                    <div class="row m-b-sm">
                        <div class="dv-label col-sm-3 strong">Name</div>
                        <div class="dv-value-edit col-sm-9">
                            <input class="form-control" name="name" ngModel maxlength="255" required>
                        </div>
                    </div>

                    <!--** Description ** -->
                    <div class="row m-b-sm">
                        <div class="dv-label col-sm-3 strong">Description</div>
                        <div class="dv-value col-sm-9">
                            <textarea class="form-control" name="description" ngModel maxlength="255" required></textarea>
                        </div>
                    </div>

                    <!--** Corporations ** -->
                    <div class="row m-b-sm">
                        <div class="dv-label col-sm-3 strong" style="padding-top: 5px;">Corporations</div>
                        <div class="dv-value col-sm-9 multiselect-with-select-field" style="padding-top: 0;">
                            <angular2-multiselect name="corporations"
                                                  [data]="directoryService.corporations"
                                                  [ngModel]="corporations"
                                                  [settings]="multiselectSettings">
                            </angular2-multiselect>
                            <spinner [spinnerShow]="directoryService.loadingCorporations "></spinner>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="onClose(form)"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/directory/create-modal/vendor-create-modal/vendor-create-modal.component.html